export const WEB_COMPONENT_NAME = "@corti/dictation-web";
export const WEB_COMPONENT_VERSION = "0.9.0";
